<template>
  <div>
    <image-rotator
      ref="imagerotater"
      :images="images"
      :videos="videos"
      @show="(image) => (shownImage = image)"
      @heliviewclick="showHeliSlides"
      :showHeliviewBtn="videos && videos.length ? true : false"
    ></image-rotator>

    <modal
      v-if="shownImage !== null"
      :no-scroll="true"
      @close="shownImage = null"
      :close-on-click="true"
      :is-open="openModal"
      class="image-modal"
    >
      <image-rotator
        :images="images"
        :videos="videos"
        :start-image="shownImage"
        :pagination-enabled="true"
        :thumbnail="false"
        :enableKeys="true"
      ></image-rotator>
    </modal>
  </div>
</template>

<script>
import ImageRotator from "./image-rotator.vue";
import Modal from "./modal.vue";

export default {
  props: {
    images: {
      type: [Object, Array],
      default() {
        return [];
      },
    },
    videos: {
      typeof: [Object, Array],
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      openModal: false,
      shownImage: null,
    };
  },
  methods: {
    showHeliSlides() {
      let heliIdx = this.$refs.imagerotater.heliSlidesIdx;
      if(heliIdx.length) {
        this.shownImage = this.$refs.imagerotater.heliSlidesIdx[0];
      }
    }
  },
  watch: {
    shownImage() {
      setTimeout(() => {
        this.openModal = this.shownImage !== null ? true : false;
      }, 250);

      this.$emit("showimage", this.shownImage);
    },
  },
  components: {
    ImageRotator,
    Modal,
  },
};
</script>
